const FilterIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="hcp-coverage-filter-icon"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.918 5.99999H2.50065V4.66666H9.918C10.214 3.51651 11.2581 2.66666 12.5007 2.66666C13.9734 2.66666 15.1673 3.86056 15.1673 5.33332C15.1673 6.80608 13.9734 7.99999 12.5007 7.99999C11.2581 7.99999 10.214 7.15014 9.918 5.99999ZM11.1673 5.33332C11.1673 4.59694 11.7643 3.99999 12.5007 3.99999C13.237 3.99999 13.834 4.59694 13.834 5.33332C13.834 6.0697 13.237 6.66666 12.5007 6.66666C11.7643 6.66666 11.1673 6.0697 11.1673 5.33332Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.08331 9.99999L14.5007 9.99999V11.3333L7.08331 11.3333C6.78728 12.4835 5.74321 13.3333 4.50065 13.3333C3.02789 13.3333 1.83398 12.1394 1.83398 10.6667C1.83398 9.1939 3.02789 7.99999 4.50065 7.99999C5.74321 7.99999 6.78728 8.84984 7.08331 9.99999ZM5.83398 10.6667C5.83398 11.403 5.23703 12 4.50065 12C3.76427 12 3.16732 11.403 3.16732 10.6667C3.16732 9.93028 3.76427 9.33332 4.50065 9.33332C5.23703 9.33332 5.83398 9.93028 5.83398 10.6667Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default FilterIcon;
